import { Result, Button } from 'antd'

export default function ({ store, navigator }) {
  return <div className='min-h-screen flex items-center justify-center'>
    <Result
      status='403'
      title='403'
      subTitle='抱歉，您的账号没有目前任何权限，请联系管理员分配权限。'
      extra={<Button type='primary' onClick={() => [ navigator.replace('/login'), store.identity.clear() ]}>切换账号</Button>}
    />
  </div>
}
